import React, { useState } from "react";
import { message } from "antd";
import axios from "../../axios/AxiosInstance";
import { freelanceCommercialName } from "../../utils/freelanceCommercial";

const groups = [
  ["Identité", [["denomination", "Nom de la société", "text", true], ["siret", "SIRET"], ["ape", "Code APE"], ["TVA", "TVA intracommunautaire"]]],
  ["Siège social", [["address", "Adresse"], ["postCode", "Code postal"], ["town", "Ville"]]],
  ["Livraison", [["addressLivraison", "Adresse"], ["postCodeLivraison", "Code postal"], ["townLivraison", "Ville"]]],
  ["Facturation", [["addressFacturation", "Adresse"], ["postCodeFacturation", "Code postal"], ["townFacturation", "Ville"]]],
  ["Conditions et suivi commercial", [["facturation", "Conditions de paiement"], ["tvaRate", "Taux de TVA"], ["clientAcquisition", "Mode d’acquisition"]]],
];

export default function EditClientInfoForm({ client, onClose, onSaved }) {
  const [form, setForm] = useState(() => Object.fromEntries(groups.flatMap(([, fields]) => fields.map(([key]) => [key, key === "denomination" ? client.companyName || client.denomination || "" : key === "ape" ? client.APE || client.ape || "" : client[key] ?? ""]))));
  const [saving, setSaving] = useState(false);
  const submit = async (event) => {
    event.preventDefault();
    if (saving) return;
    if (!form.denomination.trim()) { message.error("Renseignez le nom de la société."); return; }
    setSaving(true);
    try {
      const values = Object.fromEntries(Object.entries(form).map(([key, value]) => [key, String(value).trim()]));
      const ownName = freelanceCommercialName();
      const payload = { ...values, companyName: values.denomination, ...(ownName ? { commercial: ownName } : {}) };
      if (Object.prototype.hasOwnProperty.call(client, "APE")) payload.APE = values.ape;
      const { data } = await axios.patch(`client/${client._id}`, payload);
      onSaved({ ...client, ...payload, ...data });
      message.success("Informations du client enregistrées.");
      onClose();
    } catch {
      message.error("Impossible d’enregistrer les modifications. Réessayez.");
    } finally {
      setSaving(false);
    }
  };
  return (
      <form onSubmit={submit} aria-label="Modifier les informations du client">
        <div className="grid grid-cols-1 gap-4 py-4 lg:grid-cols-2">
          {groups.map(([title, fields]) => (
            <fieldset key={title} disabled={saving} className="min-w-0 rounded-xl border border-blue-200 bg-blue-50/40 p-5">
              <legend className="mb-3 text-sm font-semibold text-slate-900">{title}</legend>
              <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                {fields.map(([key, label, type = "text", required = false]) => (
                  <label key={key} htmlFor={`edit-client-${key}`} className="block text-sm text-slate-600">
                    {label}{required && " *"}
                    <input id={`edit-client-${key}`} name={key} type={type} required={required} value={form[key]} onChange={(event) => setForm((current) => ({ ...current, [key]: event.target.value }))} className="mt-1 block w-full rounded-lg border border-slate-300 px-3 py-2 text-slate-900 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-100 disabled:bg-slate-50" />
                  </label>
                ))}
              </div>
            </fieldset>
          ))}
        </div>
        <p className="mb-4 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">Commercial : {freelanceCommercialName() || client.commercial || "votre nom"}. Il est enregistré automatiquement avec votre nom.</p>
        <div className="flex justify-end gap-3 border-t border-slate-200 pt-4">
          <button type="button" disabled={saving} onClick={onClose} className="rounded-lg border border-slate-300 px-4 py-2 text-sm font-medium disabled:opacity-50">Annuler</button>
          <button type="submit" disabled={saving} className="rounded-lg bg-blue-700 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-800 disabled:opacity-50">{saving ? "Enregistrement…" : "Enregistrer"}</button>
        </div>
      </form>
  );
}
